/* eslint-disable no-prototype-builtins */
/* eslint-disable no-undef */
import * as EXP from './constants';

import URI from 'urijs';

import { setupPhoneInputEvents } from './phone-input-module';
const currentUrl = window.location.href;

const ThirdParty = {
  onLeadSquareSubmit: () => {
    (function ($) {
      $('#pum-4188 .pum-close').css('display', 'block'); //
      $('#frmrlp-block-10').on('submit', function (event) {
        event.preventDefault();
        const formVariables = {
          SubscribeFormId: 'cc192906-f354-11eb-8573-06ff16d87222',
          fields: {
            EmailAddress: 'EmailAddress',
          },
        };
        ThirdParty.createCookieOnFormSubmit(formVariables);
        return false;
      });
    })(jQuery);
  },
  onGatedFormSubmit: () => {
    (function ($) {
      $('#pum-4152 .pum-close').css('display', 'none');
      $('#frmrlp-block-14').on('submit', function (event) {
        event.preventDefault();
        const formVariables = {
          SubscribeFormId: 'e3f09c38-f353-11eb-8573-06ff16d87222',
          fields: {
            FirstName: 'FirstName',
            LastName: 'LastName',
            EmailAddress: 'EmailAddress',
            Phone: 'Phone',
            JobTitle: 'JobTitle',
            Company: 'Company',
          },
        };
        ThirdParty.createCookieOnFormSubmit(formVariables);
        return false;
      });
    })(jQuery);
  },
  createCookieOnFormSubmit: (formVariables) => {
    (function ($) {
      /* Step 01 - Map fields*/
      const fieldMapping = {
        MXHOrgCode: '8287',
        MXHLandingPageId: formVariables.SubscribeFormId,
        MXHAsc: '5',
        ...formVariables.fields,
      };
      /*Step 02 - Add callbacks*/
      const onSuccess = function () {
        /* Success callback code goes here cookiecreate */
        const signUpLeadSquareCookieName = $(`#${formVariables.SubscribeFormId}`).data('cookie');
        const isSignUpLeadSquareCookieSet = Cookies.get(signUpLeadSquareCookieName);
        if (!isSignUpLeadSquareCookieSet) {
          Cookies.set(signUpLeadSquareCookieName, 'true');
          // $(`#${signUpLeadSquareCookieName}`).css('display', 'block');
          $(`#${signUpLeadSquareCookieName}`).css('display', 'none'); //
        }
        $('#popmake-4188').css('display', 'none'); //
        $('html').removeClass('pum-open pum-open-overlay pum-open-scrollable'); //
      };
      const onError = function () {
        /*Error callback code is given below*/
        console.log('error');
      };

      /*Step - 03 Capture Lead in LeadSquared*/
      new LSQForm().captureLead(fieldMapping, formVariables.SubscribeFormId, {
        onSuccess: onSuccess /*optional*/,
        onError: onError /*optional*/,
      });
    })(jQuery);
  },
  activateMarketoForms: (formIds) => {
    formIds.forEach(function (formId) {
      var loadForm = MktoForms2.loadForm.bind(MktoForms2, EXP.POD_ID, EXP.MUNCHKIN_ID, formId),
        formEls = [].slice.call(document.querySelectorAll('[' + EXP.MKTOFORM_ID_ATTRNAME + '="' + formId + '"]'));
      var form_els = [];
      for (let i = 0; i < formEls.length; i++) {
        form_els.push(formEls[i]);
      }

      (function loadFormCb(formEls) {
        var formEl = formEls.shift();
        formEl.id = EXP.MKTOFORM_ID_PREFIX + formId;

        loadForm(function () {
          formEl.id = '';
          formEls.length && loadFormCb(formEls);
        });
      })(form_els);
    });
  },

  // sendFormDataToFactorOnMarketoFormSubmit: (formData) => {
  //   const formId = formData.getId();
  //   let formType;
  //   let passThroughVars = {};
  //   let email = '';
  //   if (formId === 1017) {
  //     formType = 'Resource Download';
  //     const {
  //       FirstName,
  //       LastName,
  //       Phone,
  //       Title,
  //       Company,
  //       Industry,
  //       Industry_Sub_Type__c,
  //       Country__c,
  //       Email: email_address,
  //     } = formData.getValues();
  //     email = email_address;
  //     passThroughVars = {
  //       [`$first_name`]: FirstName,
  //       [`$last_name`]: LastName,
  //       [`$phone`]: Phone,
  //       [`$title`]: Title,
  //       [`$company`]: Company,
  //       [`$industry`]: Industry,
  //       [`$industry_sub_type__c`]: Industry_Sub_Type__c,
  //       [`$country__c`]: Country__c,
  //     };
  //   }
  //   if (formId === 1016) {
  //     formType = 'Subscribe Blog';
  //     const { Email: email_address } = formData.getValues();
  //     email = email_address;
  //     passThroughVars = {};
  //   }

  // if (email) {
  //   factors.track('$form_submitted', {
  //     $channel_type: 'form', //The value will change based on signup actions (google-sso, facebook-sso, github-sso or form for default email based login)
  //     $formType: formType, //This is going to be the form name/title
  //     $email: email, //Email to be $email always
  //     ...passThroughVars,
  //     $form_submission: 'success', //This is mandatory field for form submission state.
  //   });
  // }
  // },

  queryStringToObject: (url) => [...new URLSearchParams(url.split('?')[1])].reduce((a, [k, v]) => ((a[k] = v), a), {}),

  salesForce: () => {
    (function ($) {
      const uri = new URI(currentUrl);
      const queryParams = ThirdParty.queryStringToObject(currentUrl);

      const currentUrlWithoutParam = uri.search('');
      ThirdParty.onSalesForceFormOpen(currentUrlWithoutParam);
      // Modal open
      $('.post-list').on('click', '.btn-close-salesforce-modal', function () {
        const targetModal = $(this).data('bs-target'); // Get the target modal ID
        // input with class mobile were not detected inside modal which is why initialisation of intlTelInput should be added here

        const $successFormMessageWrapper = $('.success-form-message');
        $successFormMessageWrapper.hide();
        $successFormMessageWrapper.addClass('SFcontactGTMtrigger');
        $('.salesforce-landing-page-form').show();
        $(`${targetModal}`).on('shown.bs.modal', function () {
          const $phoneInputs = $(this).find('.mobile');

          if ($phoneInputs.length > 0) {
            $phoneInputs.each(function () {
              const $input = $(this);
              setupPhoneInputEvents($input);
            });
          }
        });
        ThirdParty.onSalesForceFormOpen(currentUrlWithoutParam, targetModal, queryParams);
      });
    })(jQuery);
  },

  onSalesForceFormOpen: (currentUrlWithoutParam, parentContainerId, queryParams) => {
    if ($('div').hasClass('salesforce_container') || parentContainerId) {
      // success
      $.validator.addMethod(
        'nameValidation',
        function (value, element) {
          // Regular expression pattern to validate the name
          var pattern = /^(?!.*\d)[\p{L}\p{M}'@ ,+\-_]+$/u;
          return this.optional(element) || pattern.test(value);
        },
        'Please enter a valid name without numbers.'
      );

      $.validator.addMethod('customEmail', function (value, element) {
        const disallowedDomains = EXP.DISALLOWED_DOMAINS;

        // Extract domain from the email
        const validEmailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        if (!validEmailFormat) {
          return false; // invalid email address a@a (without .com)
        }

        const emailParts = value.split('@');
        if (emailParts.length !== 2 || emailParts[1].trim() === '') {
          return false;
        }

        const domain = emailParts[1].toLowerCase();

        // Check if the domain is in the list of disallowed domains
        const isDisallowedDomain = disallowedDomains.some((disallowed) => domain.includes(disallowed));

        // Display message only if the domain is disallowed
        return isDisallowedDomain ? false : true;
      });

      $.validator.addMethod(
        'phoneValidation',
        function (value, element) {
          var pattern = /^[0-9+]{6,15}$/;
          return this.optional(element) || pattern.test(value);
        },
        'Please enter a valid number.'
      );

      const mapperCookieKeyToInputFields = [
        {
          cookieKey: 'utm_source',
          inputFieldClass: '00NC6000000OQ9V',
        },
        {
          cookieKey: 'utm_medium',
          inputFieldClass: '00NC6000000OQ9a',
        },
        {
          cookieKey: 'utm_campaign',
          inputFieldClass: '00NC6000000OQ9f',
        },
        {
          cookieKey: 'utm_term',
          inputFieldClass: '00NC6000000OQ9k',
        },
        {
          cookieKey: 'utm_content',
          inputFieldClass: '00NC6000000OQ9p',
        },
        {
          cookieKey: 'gclid',
          inputFieldClass: '00NC6000000NyiJ',
        },
      ];
      // Bind click event to all buttons with class 'validate-button'
      $('.salesforce-form-submit').on('click', function () {
        const utmCookieName = 'utmParams';
        const $fieldDomainUrl = $('.00NC6000000OEa5', $salesForceLandingPageForm);

        const salesForceQuestionMapping = {
          // answerQ1: {
          //   questionWithAns: '00NHF000000Z51d',
          //   ansValue: '00NHF000000bms5',
          // }, // revamp
          answerQ1: {
            questionWithAns: '00NS2000004SUaL',
            ansValue: '00NS2000004mwqc',
          }, // live

          // answerQ2: 'shefali2',
        };

        const $submitBtn = $(this);
        // Find the parent form of the clicked button
        const $salesForceLandingPageForm = $(this).closest('form');

        // Call the validate method on the form
        $salesForceLandingPageForm.validate({
          rules: {
            last_name: {
              nameValidation: true,
            },
            email: {
              email: true,
              customEmail: true,
            },
            company: {
              required: true,
            },
            country: {
              required: true,
            },
            mobile: {
              phoneValidation: true,
            },
          },
          messages: {
            last_name: {
              nameValidation: 'This is a required field. Please enter valid input',
            },
            email: {
              email: 'Please enter a valid email address.',
              customEmail: 'Please enter a valid business email.',
            },
            company: {
              nameValidation: 'This is a required field. Please enter valid input',
            },
            country: {
              required: 'Please select a country.',
            },
            mobile: {
              phoneValidation: 'Should be a number. Please enter valid input',
            },
          },
        });

        if ($salesForceLandingPageForm.valid()) {
          const $loadingFormWrapper = $(this).closest('form').find('.form-loading-indicator');
          $loadingFormWrapper.show();
          $submitBtn.prop('disabled', true);
          const utmCookieRawValue = Cookies.get(utmCookieName);
          const utmQueryParamsAsObject =
            utmCookieRawValue && Object.keys(utmCookieRawValue).length ? JSON.parse(decodeURIComponent(utmCookieRawValue)) : {};
          const $leadType = $('.00NC6000000OQ9Q', $salesForceLandingPageForm);
          const $leadSource = $('.lead_source', $salesForceLandingPageForm);
          const $subLeadSource = $('.00N5g00000OZ5fJ', $salesForceLandingPageForm);
          const $leadMarketingSourceUrlForDirectLead = $('.00NC6000000NspJ', $salesForceLandingPageForm);
          $leadMarketingSourceUrlForDirectLead.val(currentUrl);
          if (['cpc', 'ppc', 'cps'].includes(utmQueryParamsAsObject.utm_medium)) {
            $leadType.val('Paid');
          } else if (
            utmQueryParamsAsObject.utm_medium == null ||
            utmQueryParamsAsObject.utm_medium == '' ||
            utmQueryParamsAsObject.hasOwnProperty('utm_medium')
          ) {
            $leadType.val('Direct');
          }
          if (['paid', 'cpc', 'ppc', 'cps', 'abm'].includes(utmQueryParamsAsObject.utm_medium)) {
            $leadSource.val('Performance Marketing');
            $subLeadSource.val('Website');
          } else if (
            utmQueryParamsAsObject.utm_medium == null ||
            utmQueryParamsAsObject.utm_medium == '' ||
            utmQueryParamsAsObject.hasOwnProperty('utm_medium')
          ) {
            $leadSource.val('Organic');
            $subLeadSource.val('Website');
          }
          // If neither of conditions above are true set leadType to organic
          const leadTypeVal = $leadType.val();
          if (leadTypeVal != 'Paid' && leadTypeVal != 'Direct') {
            $leadType.val('Organic');
          }
          $fieldDomainUrl.val(currentUrlWithoutParam);
          mapperCookieKeyToInputFields.map((mapper) => {
            $('.' + mapper.inputFieldClass, $salesForceLandingPageForm).val(
              utmQueryParamsAsObject.hasOwnProperty(mapper.cookieKey) ? utmQueryParamsAsObject[mapper.cookieKey] : ''
            );
          });
          // Initialize an empty string to store the form values

          var formValues = {};

          $salesForceLandingPageForm.find('input, textarea, select').each(function () {
            var $input = $(this);
            var name = $input.attr('name');
            var value = $input.val();

            // Keep the existing assignment logic
            formValues[name] = value;

            // Check if the name exists in the salesForceQuestionMapping
            if (salesForceQuestionMapping[name] && salesForceQuestionMapping[name].questionWithAns) {
              const questionWithAns = salesForceQuestionMapping[name].questionWithAns;
              // Skip unchecked radio buttons
              if ($input.is(':radio') && !$input.is(':checked')) {
                return;
              }
              var question = $input.closest('.sfdc_question_wrapper').data('question'); // Get question from the parent wrapper

              // Use the mapped name as the key and combine question and answer
              formValues[questionWithAns] = `${question}: ${value}`;

              formValues[salesForceQuestionMapping[name].ansValue] = `${value}`;
            }
          });

          // if (formValues.email != 's@gupshup.io') {
          //   console.log(formValues);
          $.ajax({
            url: wpCustomVariables.ajaxUrl,
            type: 'POST',
            data: {
              action: 'process_salesforce_form',
              formValues: formValues,
            },
            success: function (response, textStatus, jqXHR) {
              $loadingFormWrapper.hide();

              if (jqXHR.status === 200) {
                const responseData = JSON.parse(response);
                if (responseData && responseData.status) {
                  const $formMessageWrapper = $salesForceLandingPageForm.prev('.success-form-message');
                  if (responseData.status === 'success') {
                    // Check if 'redirect_url' is present and not empty or undefined
                    if (
                      responseData &&
                      responseData.redirect_url !== undefined &&
                      responseData.redirect_url !== '' &&
                      responseData.redirect_url !== '?'
                    ) {
                      // Redirect to the specified URL
                      window.location.href = responseData.redirect_url;
                    }
                    // Perform actions for a successful response
                    $formMessageWrapper.removeClass('alert-danger').addClass('alert-success').text(responseData.message).show();
                    $formMessageWrapper.addClass('SFcontactGTMtrigger');
                    $salesForceLandingPageForm.hide();
                  } else if (responseData.status === 'failure') {
                    console.error('Failure:', responseData.message);
                    $formMessageWrapper.removeClass('alert-success').addClass('alert-danger');
                    $formMessageWrapper.text(responseData.message).show();
                  }
                }
              } else {
                console.error('Unexpected HTTP status code:', jqXHR.status);
              }
            },
            error: function (error) {
              $loadingFormWrapper.hide();
              console.error('Error:', error);
            },
          });

          window.dataLayer.push({
            event: 'gtm.formSubmit',
            formEmail: $('.email', $salesForceLandingPageForm).val(),
            formPhone: $('.mobile', $salesForceLandingPageForm).val(),
          });
          // }
        }
        return false;
      });
    }
  },

  onInit: () => {
    (function ($) {
      // Salesforce form execution
      ThirdParty.salesForce();
      // loop through provided Marketo form ID's and load them

      // activate any forms on page during page load
      var form_id_array = [];
      $('[data-form-id]').each(function () {
        // don't activate if in modal container
        if (
          !$(this).parent().parent().hasClass('modal_content_container') &&
          !$(this).parent().parent().hasClass('global_modal_content_container')
        ) {
          form_id_array.push($(this).data('form-id'));
        }
      });
      ThirdParty.activateMarketoForms(form_id_array);
      // considering there will be only 1 form per page
      const firstFormId = form_id_array[0];

      MktoForms2.whenReady(function (form) {
        form.onSuccess(function () {
          var $form = form.getFormElem();
          if (form.getId() === 1017) {
            // console.log('testtt');

            const hrefTraget = $('.gatedRes .button').attr('href');
            // console.log(hrefTraget);

            $('#confirmGateForm').append(
              "<a class='triggerClick' download href='" + hrefTraget + "'><br>Click Here to Download Your PDF Now</a>"
            );
            var cookieName = $form.data('cookie-name');
            if (typeof cookieName !== undefined) {
              Cookies.set(cookieName, 'true');
            }
            if ($form.data('success-msg')) {
              $form.fadeOut(500, function () {
                $('#' + $form.data('success-msg')).fadeIn(500);
                $('.hideTitle').css('display', 'none');

                if ($('body').hasClass('single-webinars')) {
                  $('#pum-6552').css('display', 'none'); //
                  $('html').removeClass('pum-open pum-open-overlay pum-open-scrollable'); //
                }

                if ($('body').hasClass('single-reports')) {
                  $('#pum-6552').css('display', 'none'); //
                  $('html').removeClass('pum-open pum-open-overlay pum-open-scrollable'); //
                  // window.location = hrefTraget;
                  window.open(hrefTraget, '_blank');
                }

                $('.gatedRes .button').trigger('click');
                $('#videoGate').css('display', 'block');
                $('.video-wrapper').css('display', 'block');
                $('.single-webinars .gatedRes .col_item_cta_content').css('display', 'block');
                $('.gatedRes img').css('display', 'none');
                // $('#videoGate')[0].src += '&autoplay=1';

                // event.preventDefault();
              });
              return false;
            }
          }
          if (form.getId() === 1016) {
            if ($form.data('success-msg')) {
              $form.fadeOut(500, function () {
                $('#' + $form.data('success-msg')).fadeIn(500);
                $('#hideTitle').css('display', 'none');
              });
              return false;
            }
          }
          if (form.getId() === 1015) {
            if ($form.data('success-msg')) {
              $form.fadeOut(500, function () {
                $('#' + $form.data('success-msg')).fadeIn(500);
                $('#hideTitleBlog').css('display', 'none');
              });
              return false;
            }
          }
          if (form.getId() === 1457) {
            // form id used in gupshup conversation 2024 event lp
            if ($form.data('success-msg')) {
              $form.fadeOut(500, function () {
                $('#' + $form.data('success-msg')).fadeIn(500);
                $('#hideTitleBlog').css('display', 'none');
              });
              return false;
            }
          }

          if (firstFormId && ![1015, 1016, 1017].includes(form.getId()) && form.getId() === firstFormId) {
            if ($form.data('success-msg')) {
              $form.fadeOut(500, function () {
                $('#' + $form.data('success-msg')).fadeIn(500);
                $('#hideTitleBlog').css('display', 'none');
              });
              return false;
            }
          }
          // if (form.getId() === 1310) {
          //   if ($form.data('success-msg')) {
          //     $form.fadeOut(500, function () {
          //       $('#' + $form.data('success-msg')).fadeIn(500);
          //       $('#hideTitleBlog').css('display', 'none');
          //     });
          //     return false;
          //   }
          // }
          // if (form.getId() === 1323) {
          //   if ($form.data('success-msg')) {
          //     $form.fadeOut(500, function () {
          //       $('#' + $form.data('success-msg')).fadeIn(500);
          //       $('#hideTitleBlog').css('display', 'none');
          //     });
          //     return false;
          //   }
          // }
          // if (form.getId() === 1334) {
          //   if ($form.data('success-msg')) {
          //     $form.fadeOut(500, function () {
          //       $('#' + $form.data('success-msg')).fadeIn(500);
          //       $('#hideTitleBlog').css('display', 'none');
          //     });
          //     return false;
          //   }
          // }
        });

        // Form factor tracking
        // form.onSubmit(function (formData) {
        //   ThirdParty.sendFormDataToFactorOnMarketoFormSubmit(formData);
        // });
      });

      function getCookie(name) {
        var dc = document.cookie;
        var prefix = name + '=';
        var begin = dc.indexOf('; ' + prefix);
        if (begin == -1) {
          begin = dc.indexOf(prefix);
          if (begin != 0) return null;
        } else {
          begin += 2;
          var end = document.cookie.indexOf(';', begin);
          if (end == -1) {
            end = dc.length;
          }
        }
        return decodeURI(dc.substring(begin + prefix.length, end));
      }

      var myCookie = getCookie('pum-6552');

      if (myCookie == null) {
        $('.single-webinars .video-wrapper').css('display', 'none');
        $('.single-webinars .gatedRes .col_item_cta_content').css('display', 'none');
      } else {
        $('.single-webinars .video-wrapper').css('display', 'block');
        $('.single-webinars .gatedRes .col_item_cta_content').css('display', 'block');
        $('.gatedRes img').css('display', 'none');
        // $('.gatedRes .button').on('click', function () {
        //   alert('tt');
        // });
      }

      var s = $('.header');
      // var topBar = $('.headerMenuWrapper');
      var headerBar = $('.headerSticky');
      // var bannerTitle = $('.headerBannerInner');
      $(window).scroll(function () {
        var windowpos = $(window).scrollTop();
        if (windowpos >= 50) {
          s.addClass('stickyHeader');
          // topBar.addClass('stickyHeader');
          headerBar.addClass('stickyHeaderBar');
          // bannerTitle.addClass('stickyTitle');
        } else if (windowpos === 0) {
          s.removeClass('stickyHeader');
          // topBar.removeClass('stickyHeader');
          headerBar.removeClass('stickyHeaderBar');
          // bannerTitle.removeClass('stickyTitle');
        }
      });
    })(jQuery);
  },
};

export default ThirdParty;
